import { useNotificationStore } from '@/store';
import { useClipboard } from '@vueuse/core';

export async function copyToClipboard(value: string) {
  const { isSupported, copy } = useClipboard();
  const { emitNotification } = useNotificationStore();

  if (!isSupported) {
    emitNotification({
      title: "Opération non supportée",
      message: "Impossible de copier dans le presse-papier depuis cette application.",
      type: "info"
    }, 7000)
  } else {
    await copy(value);
    emitNotification({
      title: "Texte copié dans le presse-papier",
    }, 3000)
  }
}